/* eslint-disable no-unused-vars */

import React from 'react';

import Icon from '@components/icon-component';

import style from './style.module.scss';
import TaskStatusAndPriority from '@components/task-status-priority';
import VesselsContainerInner from './vessel-container-inner';

const VesselsContainer = ({ moreInfoOfVessel, vesselInfo = true }) => {
  return (
    <div className={`${style.moreInfoBody} ${!vesselInfo && style.borderBottom}  `}>
      {moreInfoOfVessel?.map((moreInfoOfPSV, index) => {
        return (
          <div key={index}>
            <VesselsContainerInner moreInfoOfPSV={moreInfoOfPSV} />
          </div>
        );
      })}
      {moreInfoOfVessel?.length > 0 && vesselInfo && (
        <div className={`${style.vesselInfo} `}>
          <div>
            <Icon name={'info-question-icon'} />
            <p>Changes to PSV relationships can be made by editing the vessel record.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default VesselsContainer;
